export function dateToStr(dateObj) {
    function padding(num) {
        if (num < 10) {
            return "0" + num;
        }
        return num;
    }

    let year = dateObj.getFullYear();
    let month = padding(dateObj.getMonth() + 1);
    let date = padding(dateObj.getDate());

    return year + "-" + month + "-" + date;
}

export function dateTimeToStr(dateObj) {
    function padding(num) {
        if (num < 10) {
            return "0" + num;
        }
        return num;
    }

    let year = dateObj.getFullYear();
    let month = padding(dateObj.getMonth() + 1);
    let date = padding(dateObj.getDate());

    let hour = padding(dateObj.getHours());
    let minute = padding(dateObj.getMinutes());
    let second = padding(dateObj.getSeconds());

    return year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
}

export function dateAdd(dateObj, days) {
    dateObj.setDate(dateObj.getDate() + days);
    return dateObj;
}

export function hourAdd(dateObj, hours) {
    dateObj.setHours(dateObj.getHours() + hours);
    return dateObj;
}

export function minuteAdd(dateObj, minutes) {
    dateObj.setMinutes(dateObj.getMinutes() + minutes);
    return dateObj;
}


export function convertDateString(dateString) {
    const date = new Date(dateString);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작하므로 +1 필요
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}`;
}


export function convertToOriginalFormat(dateString) {
    if (!dateString) {
        return "";
    }

    const [datePart, timePart] = dateString.split('T');

    const [hours, minutes, seconds = '00'] = timePart.split(':');

    const formattedDateTime = `${datePart} ${hours}:${minutes}:${seconds}`;
    return formattedDateTime;
}

export function isWeekend(date) {
    const dayOfWeek = date.getDay();
    return dayOfWeek === 0 || dayOfWeek === 6; // 0: Sunday, 6: Saturday
}

export function isHoliday(date) {
    const holidays = [
        '2026-01-01',   // 신정
        '2026-03-01',   // 3.1절
        '2026-02-16',   // 설날
        '2026-02-17',   // 설날
        '2026-02-18',   // 설날
        '2026-03-02',   // 3.1 임시공휴일
        '2026-05-24',   // 부처님오신날
        '2026-05-05',   // 5.5
        '2026-05-25',   // 5.24 부처님오신날 임시공휴일
        '2026-06-03',   // 6.3 지방선거
        '2026-06-06',   // 현충일
        '2026-08-15',   // 광복절
        '2026-08-17',   // 8.15 광복절 임시공휴일
        '2026-09-24',   // 추석
        '2026-09-25',   // 추석
        '2026-09-26',   // 추석
        '2026-10-03',   // 개천절
        '2026-10-05',   // 개천절 임시공휴일
        '2026-10-09',   // 한글날
        '2026-12-25',   // 크리스마스
        '2027-01-01',   // 신년
        '2027-02-06',   // 설날 연휴
        '2027-02-07',   // 설날
        '2027-02-08',   // 설날
        '2027-02-09',   // 설날 연휴
        '2027-03-01',   // 3.1절
        '2027-05-05',   // 어린이날
        '2027-05-13',   // 부처님오신날
        '2027-06-06',   // 현충일
        '2027-08-15',   // 광복절
        '2027-08-16',   // 광복절 대체공휴일
        '2027-09-14',   // 추석 연휴
        '2027-09-15',   // 추석
        '2027-09-16',   // 추석 연휴
        '2027-10-03',   // 개천절
        '2027-10-04',   // 개천절 대체공휴일
        '2027-10-09',   // 한글날
        '2027-10-11',   // 한글날 대체공휴일
        '2027-12-25',   // 크리스마스
        '2027-12-27',   // 크리스마스 대체공휴일
    ];

    const formattedDate = dateToStr(date);
    return holidays.includes(formattedDate);
}

export function calculateBusinessDays(startDate, daysToAdd) {
    const date = new Date(startDate);
    let addedDays = 0;

    while (addedDays < daysToAdd) {
        dateAdd(date, 1);

        if (!isWeekend(date) && !isHoliday(date)) {
            addedDays++;
        }
    }

    return date;
}

export function isMoreThanOneHour(givenTimeStr) {
    const givenTime = new Date(givenTimeStr); // Parse the given time string
    const currentTime = new Date(); // Get the current time

    const timeDifference = givenTime - currentTime; // Difference in milliseconds
    const oneHourInMilliseconds = 60 * 60 * 1000; // 1 hour in milliseconds

    return timeDifference > oneHourInMilliseconds; // Return true if more than 1 hour
}

export const hourList = [
    { label: '09',	value: '09' },
    { label: '10',	value: '10' },
    { label: '11',	value: '11' },
    { label: '12',	value: '12' },
    { label: '13',	value: '13' },
    { label: '14',	value: '14' },
    { label: '15',	value: '15' },
    { label: '16',	value: '16' },
    { label: '17',	value: '17' },
    { label: '18',	value: '18' },
]
export const hourListForMapticsSend = [
    { label: '09',	value: '09' },
    { label: '10',	value: '10' },
    { label: '11',	value: '11' },
    { label: '12',	value: '12' },
    { label: '13',	value: '13' },
    { label: '14',	value: '14' },
    { label: '15',	value: '15' },
    { label: '16',	value: '16' },
    { label: '17',	value: '17' },
    { label: '18',	value: '18' },
    { label: '19',	value: '19' },
]
export const hourListForMapticsSchedule = [
    ...hourListForMapticsSend,
    { label: '20',	value: '20' },
]
export const hourListForMapticsCollect = [
    { label: '00',	value: '00' },
    { label: '01',	value: '01' },
    { label: '02',	value: '02' },
    { label: '03',	value: '03' },
    { label: '04',	value: '04' },
    { label: '05',	value: '05' },
    { label: '06',	value: '06' },
    { label: '07',	value: '07' },
    { label: '08',	value: '08' },
    { label: '09',	value: '09' },
    { label: '10',	value: '10' },
    { label: '11',	value: '11' },
    { label: '12',	value: '12' },
    { label: '13',	value: '13' },
    { label: '14',	value: '14' },
    { label: '15',	value: '15' },
    { label: '16',	value: '16' },
    { label: '17',	value: '17' },
    { label: '18',	value: '18' },
    { label: '19',	value: '19' },
    { label: '20',	value: '20' },
    { label: '21',	value: '21' },
    { label: '22',	value: '22' },
    { label: '23',	value: '23' },
]
export const minuteList = [
    { label: '00',	value: '00' },
    { label: '10',	value: '10' },
    { label: '20',	value: '20' },
    { label: '30',	value: '30' },
    { label: '40',	value: '40' },
    { label: '50',	value: '50' },
]
